
const en = {
  // Navigation
  'navigation.home': 'Home',
  'navigation.music': 'Music',
  'navigation.about': 'About',
  'navigation.videos': 'Videos',
  'navigation.contact': 'Contact',

  // Home page
  'home.hero_title_1': 'JEAN-CLAUDE',
  'home.hero_title_2': 'BASTOS',
  'home.hero_subtitle': 'UK ELECTRONIC POWERHOUSE',
  'home.hero_description': 'Creating high-energy tracks with cinematic edge',
  'home.cta_experience': 'EXPERIENCE THE SOUND',
  'home.cta_connect': 'CONNECT',
  'home.latest_releases': 'LATEST RELEASES',
  'home.latest_releases_subtitle': 'HIGH-ENERGY ELECTRONIC TRACKS WITH CINEMATIC EDGE',
  'home.track_1_title': 'Break the Ground',
  'home.track_1_desc': 'EXPLOSIVE PROGRESSIVE HOUSE WITH DEVASTATING DROPS',
  'home.track_2_title': 'Running Free',
  'home.track_2_desc': 'SUMMER ANTHEM WITH EUPHORIC UPLIFTING MELODIES',
  'home.track_3_title': 'When We Loved',
  'home.track_3_desc': 'EMOTIONAL MELODIC JOURNEY WITH AMBIENT BREAKDOWNS',
  'home.about_title_1': 'UK ELECTRONIC',
  'home.about_title_2': 'MUSIC PRODUCER',
  'home.about_text_1': 'Jean-Claude Bastos is a UK-based electronic powerhouse creating high-energy tracks with cinematic edge. He combines elements of progressive house, melodic techno, and ambient-inspired breakdowns.',
  'home.about_text_2': 'His sound is designed to move both crowds and headphones, equally suited for electronic music enthusiasts and late-night playlists.',
  'home.cta_discover': 'DISCOVER THE JOURNEY',
  'home.quote': 'My favorite songs have always felt like POSTCARDS FROM PLACES I\'ve never been. That\'s what I try to create—SOUNDTRACKS FOR PLACES that only exist when you close your eyes.',
  'home.quote_author': '— JEAN-CLAUDE BASTOS',
  'home.final_cta_title': 'EXPERIENCE THE SOUND',
  'home.final_cta_subtitle': 'EXPLORE THE SOUND. FEEL THE BUILD. JOIN THE JOURNEY.',
  'home.cta_listen': 'LISTEN NOW',
  'home.cta_website': 'OFFICIAL WEBSITE',

  // About page
  'about.hero_title': 'About',
  'about.hero_subtitle': 'The story behind the music and the journey of Jean-Claude Bastos',
  'about.main_title': 'Jean-Claude Bastos',
  'about.main_text_1': 'Jean-Claude Bastos is a UK-based electronic music producer creating high-energy tracks with cinematic edge. He combines elements of progressive house, melodic techno, and ambient-inspired breakdowns, his sound designed to move both electronic music fans and headphones.',
  'about.main_text_2': 'With early releases like Running Free, Break the Ground, and When We Loved, Bastos has quickly built a reputation for immersive production and versatile energy — perfect for electronic music enthusiasts and late-night playlists.',
  'about.main_text_3': 'Whether you\'re discovering his beats for the first time or following every new drop, this journey represents the official hub for everything Jean-Claude Bastos. Explore the sound. Feel the build. Join the journey.',
  'about.music_style': 'Music Style',
  'about.music_style_desc': 'Progressive House, Melodic Techno & Ambient Breakdowns',
  'about.based_in': 'Based In',
  'about.based_in_desc': 'United Kingdom',
  'about.quote': 'Beats are like colors to me – every melody paints a new mood. My music should capture moments that can\'t be preserved with photos, only with sounds.',
  'about.quote_author': '– DJ Jean-Claude Bastos',
  'about.journey_title': 'Musical Journey',
  'about.journey_subtitle': 'From early inspirations to breakthrough releases',
  'about.journey_1_title': 'Early Beginnings',
  'about.journey_1_desc': 'Started with a passion for emotional soundscapes that transport listeners to new worlds',
  'about.journey_2_title': 'Breakthrough Releases',
  'about.journey_2_desc': 'Running Free, Break the Ground, and When We Loved established his unique sound in the electronic music scene',
  'about.journey_3_title': 'Future Vision',
  'about.journey_3_desc': 'Continues to push boundaries with immersive production and cinematic electronic experiences',
  'about.website_cta_title': 'Visit Official Website',
  'about.website_cta_desc': 'For exclusive access to new music, streaming links, video content, and behind-the-scenes insights into Jean-Claude\'s creative process.',

  // Contact page
  'contact.hero_title': 'Contact',
  'contact.hero_subtitle': 'For press inquiries, collaborations, or just to connect',
  'contact.get_in_touch': 'Get in Touch',
  'contact.location_title': 'Location',
  'contact.location_desc': '📍 United Kingdom',
  'contact.email_title': 'Email',
  'contact.email_desc': '📧 Available via contact form',
  'contact.specialization_title': 'Specialization',
  'contact.specialization_desc': 'Progressive House • Melodic Techno • Electronic Music Production',
  'contact.website_title': 'Official Website',
  'contact.follow_title': 'Follow the Journey',
  'contact.form_title': 'Send a Message',
  'contact.form_name': 'Full Name *',
  'contact.form_name_placeholder': 'Your full name',
  'contact.form_email': 'Email Address *',
  'contact.form_email_placeholder': 'your.email@example.com',
  'contact.form_message': 'Message * (max. 500 characters)',
  'contact.form_message_placeholder': 'Tell me about your press inquiry, collaboration ideas, or just say hi...',
  'contact.form_characters': 'characters',
  'contact.form_sending': 'Sending...',
  'contact.form_send': 'Send Message',
  'contact.form_success': 'Thank you! Your message has been sent successfully.',
  'contact.form_error': 'Error sending message. Please try again.',
  'contact.services_title': 'Creative Focus',
  'contact.services_subtitle': 'High-energy electronic music creation and production',
  'contact.service_1_title': 'Music Production',
  'contact.service_1_desc': 'High-energy electronic tracks designed to move both crowds and headphones, with cinematic edge',
  'contact.service_2_title': 'Sound Design',
  'contact.service_2_desc': 'Immersive audio experiences with melodic techno and progressive house elements',
  'contact.service_3_title': 'Creative Collaborations',
  'contact.service_3_desc': 'Working with other artists and producers for innovative electronic music projects',

  // Music page
  'music.hero_title': 'Music',
  'music.hero_subtitle': 'Discover the latest releases and tracks from Jean-Claude Bastos',
  'music.latest_releases': 'LATEST RELEASES',
  'music.more_tracks': 'MORE TRACKS',
  'music.play_on': 'Play on',
  'music.duration': 'Duration',

  // Videos page
  'videos.hero_title': 'Videos',
  'videos.hero_subtitle': 'Music videos and creative content from Jean-Claude Bastos',
  'videos.music_videos': 'Music Videos',
  'videos.official_content': 'Official music videos and visual content from Jean-Claude Bastos',
  'videos.subscribe_youtube': 'Subscribe on YouTube',
  'videos.watch_youtube': 'Watch on YouTube',
  'videos.views': 'Views',
  'videos.duration': 'Duration',
  'videos.stay_connected': 'Stay Connected',
  'videos.subscribe_message': 'Subscribe to the YouTube channel for exclusive content and latest releases',
  'videos.subscribe_now': 'Subscribe Now',
  'videos.listen_music': 'Listen to Music',

  // Footer
  'footer.made_with': 'Made with',
  'footer.rights': 'All rights reserved.',

  seo: {
    title: 'Jean-Claude Bastos | UK DJ & EDM Producer',
    description: 'Jean-Claude Bastos is a UK-based DJ and EDM producer bringing high-energy beats and summer anthems to fans worldwide. Discover his music, mixes, and latest releases.',
    keywords: 'Jean-Claude Bastos, UK DJ, EDM Producer, Electronic Dance Music, Progressive House, Break the Ground, Running Free, When We Loved, UK electronic music, EDM artist, electronic music producer',
    home: {
      title: 'Jean-Claude Bastos | UK Electronic Music Producer & DJ',
      description: 'Experience the electrifying world of Jean-Claude Bastos, UK\'s rising electronic music sensation. High-energy EDM tracks, progressive house beats, and cinematic electronic experiences. Stream Break the Ground, Running Free, and When We Loved.',
      keywords: 'Jean-Claude Bastos, UK electronic music, EDM producer, progressive house, Break the Ground, Running Free, When We Loved, UK DJ, electronic dance music'
    },
    music: {
      title: 'Music | Jean-Claude Bastos - Latest EDM Tracks & Electronic Releases',
      description: 'Explore Jean-Claude Bastos\' complete music catalog. Stream and discover the latest EDM tracks including Break the Ground, Running Free, When We Loved, and more progressive house anthems.',
      keywords: 'Jean-Claude Bastos music, EDM tracks, progressive house, electronic music releases, Break the Ground, Running Free, When We Loved, UK electronic music'
    },
    videos: {
      title: 'Music Videos | Jean-Claude Bastos - Official Electronic Music Videos',
      description: 'Watch Jean-Claude Bastos\' official music videos including Break the Ground, Running Free, When We Loved, and Firestarter Hearts. High-quality electronic music video content.',
      keywords: 'Jean-Claude Bastos videos, electronic music videos, Break the Ground video, Running Free video, When We Loved video, EDM music videos, UK electronic music'
    },
    about: {
      title: 'About Jean-Claude Bastos | UK Electronic Music Producer Biography',
      description: 'Learn about Jean-Claude Bastos, the UK-based electronic music producer creating high-energy tracks with cinematic edge. Discover his musical journey, style, and artistic vision.',
      keywords: 'Jean-Claude Bastos biography, UK electronic music producer, progressive house artist, melodic techno, electronic music biography, UK DJ background'
    },
    contact: {
      title: 'Contact Jean-Claude Bastos | Electronic Music Producer Inquiries',
      description: 'Get in touch with Jean-Claude Bastos for press inquiries, music collaborations, bookings, and business opportunities. Contact the UK electronic music producer today.',
      keywords: 'Jean-Claude Bastos contact, electronic music producer contact, UK DJ booking, music collaboration, press inquiries, EDM producer contact'
    }
  }
};

export default en;
